import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';

export interface FeedbackInput {
  feedbackType: string;
  feedbackText: string;
  rating?: number;
  feedbackSource: 'popup' | 'footer' | 'other';
  pageUrl?: string;
  sessionDuration?: number;
}

export async function submitFeedback(
  feedbackData: FeedbackInput,
  user: User | null
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase.from('user_feedback').insert({
      user_id: user?.id || null,
      feedback_type: feedbackData.feedbackType,
      feedback_text: feedbackData.feedbackText,
      rating: feedbackData.rating || null,
      feedback_source: feedbackData.feedbackSource,
      page_url: feedbackData.pageUrl || window.location.href,
      session_duration: feedbackData.sessionDuration || null,
    });

    if (error) {
      throw error;
    }

    return { success: true };
  } catch (error: any) {
    console.error('Error submitting feedback:', error);
    return {
      success: false,
      error: error.message || 'Failed to submit feedback',
    };
  }
}

export async function getUserFeedback(
  user: User
): Promise<any[]> {
  try {
    const { data, error } = await supabase
      .from('user_feedback')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Error fetching user feedback:', error);
    return [];
  }
} 